import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DataList } from "@/common/DataList";
import type { GeneralInfoTabFormValues } from "@/entities/general-info-tab-content/model";
import { SocialNetworkField } from "./SocialNetworkField";

type Props = {
  personId: string;
  isEditMode: boolean;
  handleEditMode: () => void;
  onSubmit: (data: GeneralInfoTabFormValues) => void;
  disabled?: boolean;
};

export const SocialNetworksList = ({
  personId,
  isEditMode,
  handleEditMode,
  onSubmit,
  disabled,
}: Props) => {
  const { t } = useTranslation();

  const { control, getValues, trigger } = useFormContext<GeneralInfoTabFormValues>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "socialNetworks",
  });

  const onBlur = async () => {
    const isValid = await trigger("socialNetworks");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  const onChange = () => {
    trigger("socialNetworks");
  };

  const addHandler = () => {
    if (!isEditMode) {
      handleEditMode();
    }

    setTimeout(() => {
      append({
        socialNetworkType: { name: "" },
        socialNetwork: "",
        personId,
        id: undefined,
      });
    }, 0);
  };

  const removeHandler = async (index: number) => {
    remove(index);

    const isValid = await trigger("socialNetworks");

    if (isValid) {
      const formData = getValues();
      onSubmit(formData);
    }
  };

  return (
    <DataList
      data={fields.map((field) => ({
        id: field.id,
        label: field.socialNetworkType?.name ?? "",
        value: field.socialNetwork ?? "",
      }))}
      onAddClick={addHandler}
      onTrashClick={removeHandler}
      isEdit={isEditMode}
      title={t("contactsPage.generalInfo.socialNetworks")}
      editNode={(index) => <SocialNetworkField index={index} onBlur={onBlur} onChange={onChange} />}
      disabled={disabled}
    />
  );
};
